import { FC, ReactNode } from "react";
import { Flex, FlexProps } from "@chakra-ui/react";

interface Props extends FlexProps {
  children: ReactNode;
}
export const QuestionContainer: FC<Props> = ({ children, ...props }) => (
  <Flex direction="column" gap={6} {...props}>
    {children}
  </Flex>
);
